import { recipeModalData } from "@/utils/aemDefaultData";
import { AemRecipeModelData } from "@/utils/types/aem";
import {
  Box,
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Text,
} from "@dxp-feed/ui";

const SaveReminder = ({
  isProgressModal,
  closeIsProgressModal,
  saveRecipesToFolder,
  aemRecipeModelData,
  saveAnywayDisable = false,
}: {
  isProgressModal: boolean;
  closeIsProgressModal: () => void;
  saveRecipesToFolder: () => void;
  aemRecipeModelData: AemRecipeModelData;
  saveAnywayDisable ?: boolean;
}) => {
  return (
    <Dialog
      isOpen={isProgressModal}
      onClose={closeIsProgressModal}
      className="max-w-[90%] md:max-w-[432px] px-6 py-4 "
    >
      <DialogHeader className="items-start">
        <Text as="h2" className="font-bold max-w-[250px]">
          {aemRecipeModelData?.closeTitle ?? recipeModalData[0]?.closeTitle}
          {/* If you close this window, your progress will be lost. */}
        </Text>
        <Button
          className="text-brandSecondary font-bold text-lg rounded-none"
          onClick={closeIsProgressModal}
          aria-label="Close modal"
          variant="icon"
          size="none"
        >
          <Text
            as="span"
            className="demo-icon icon-close text-brandBlack text-[14px] "
          ></Text>
        </Button>
      </DialogHeader>
      <DialogBody className="max-h-[325px] custom-scroll">
        <Text as="h2" className=" font-normal text-body">
          {aemRecipeModelData?.closeMessage ?? recipeModalData[0]?.closeMessage}
          {/* Make sure to save before exiting! */}
        </Text>
      </DialogBody>
      <DialogFooter className="">
        <Box as="div" className="flex w-full justify-end gap-2">
          <Button
            variant="primary"
            className="border-0 bg-transparent focus:text-brandPrimary hover:text-brandPrimary focus:bg-transparent  text-brandPrimary font-bold [&:hover]:border-0 [&:hover]:bg-transparent text-[14px] focus:border-brandPrimary w-[118px] p-0 underline"
            onClick={closeIsProgressModal}
            aria-label={aemRecipeModelData?.closeAnyway ?? recipeModalData[0]?.closeAnyway}
          >
            {aemRecipeModelData?.closeAnyway ?? recipeModalData[0]?.closeAnyway}
            {/* Close Anyway */}
          </Button>
          <Box as="div" className="flex ">
            <Button
              variant="primary"
              className="text-[14px] font-normal bg-brandPrimary border-brandPrimary hover:border-brandPrimary hover:text-brandPrimary 
              focus:border-brandPrimary hover:bg-brandPrimary  focus:text-brandPrimary focus:bg-transparent w-[151px]"
              onClick={saveRecipesToFolder}
              aria-label={aemRecipeModelData?.saveRecipeList ?? recipeModalData[0]?.saveRecipeList}
            >
              {aemRecipeModelData?.saveRecipeList ?? recipeModalData[0]?.saveRecipeList}
              {/* Save Recipe List */}
            </Button>
          </Box>
        </Box>
      </DialogFooter>
    </Dialog>
  );
};

export default SaveReminder;
